import { render, staticRenderFns } from "./SelectContainerType.vue?vue&type=template&id=c68b9e24&lang=pug&"
import script from "./SelectContainerType.vue?vue&type=script&lang=js&"
export * from "./SelectContainerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports